import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/success.png'


const _withScopeId = n => (_pushScopeId("data-v-2d0883e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "success",
  style: {"margin-top":"1rem"}
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_3 = { style: {"margin-top":"0.2rem"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("返回首页")
const _hoisted_5 = { class: "overlay-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("加载中...")

import router from "@/router";
import { Button, Loading } from "vant";
import { request } from "@/provide/fetch";
import { ref } from "vue";
import { useRoute } from "vue-router";

export default /*#__PURE__*/_defineComponent({
  name: 'Success',
  setup(__props) {

const isPayFlag = ref(false);
const route = useRoute();
const payNo = route.query.payNo;
const visible = ref(true);
const init = () => {
  request({
    url: `/card-order/pay/callback?payNo=${payNo}`,
  }).then((res) => {
    if (res.data) {
      visible.value = false;
      isPayFlag.value = true;
    } else {
      router.push({
        path: "/OrderPage",
        query: {
          status: "已完成"
        }
      });
      // setTimeout(() => {
      //   init();
      // }, 3000);
    }
  });
};
init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      (isPayFlag.value)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true),
      (!isPayFlag.value)
        ? (_openBlock(), _createBlock(_unref(Loading), {
            key: 1,
            type: "spinner",
            color: "#1989fa"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(isPayFlag.value ? "恭喜！办理成功" : "办理中，请稍后..."), 1),
      _createVNode(_unref(Button), {
        block: "",
        type: "primary",
        style: {"width":"60%","margin-left":"20%","margin-top":"0.5rem"},
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/')))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, !visible.value]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(Loading), {
        color: "#0094ff",
        size: "24px",
        vertical: ""
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, visible.value]
    ])
  ], 64))
}
}

})